export default __webpack_public_path__ + "static/media/camera.e1f37e61.svg";